import { AfterViewInit, Component } from '@angular/core';
import { AppComponent } from '../../app.component';
import { HttpClient } from '@angular/common/http';
import { AppConfigQuery } from '../state/app-config/app-config.query';

@Component({
    selector: 'app-sb-footer',
    templateUrl: './sb-footer.component.html',
    styleUrls: ['./sb-footer.component.scss']
})
export class SbFooterComponent implements AfterViewInit {
    version: String;
    serverVersion: String;
    year: number = new Date().getFullYear();

    constructor(
        public app: AppComponent,
        private appConfig: AppConfigQuery,
        private http: HttpClient
    ) {}

    ngAfterViewInit(): void {
        this.http
            .get(this.appConfig.get().gatewayBaseUrl + '/app/buildVersion')
            .toPromise()
            .then((response) => {
                this.serverVersion = response['version'];
            });

        setTimeout(() => {
            this.version = this.appConfig.get()?.buildVersion;
        }, 100);
    }
}
